/**
 * Flow C · AI routes — WP-C.
 *
 * C1 `/ai` · C2 `/ai/:conversationId` · C3 `/ai/:id/compare` · C4 `/ai/:id/plan`
 * C5 `/ai/:id/budget`
 *
 * The manifest names the C2 parameter `:conversationId` and C3–C5's `:id`. They are the
 * same value; both names are kept because the manifest is the contract the harness reads,
 * and renaming one here would make a route that no fixture matches.
 *
 * C3–C5 are declared before C2 so `/ai/x/compare` is not swallowed by `/ai/:id`. The
 * conversation the frames are drawn against is `ac-today`, so the harness fixtures are
 * `C2: { "conversationId": "ac-today" }` and `C3/C4/C5: { "id": "ac-today" }`. `tools/`
 * is outside this package's grant, so those values are reported rather than written.
 *
 * App.tsx mounts this array; it is not edited from here.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import {
  AiIndexScreen,
  BudgetScreen,
  CompareScreen,
  ConversationScreen,
  PlanScreen,
} from './ai.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (ai · এআই); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const aiRoutes: RouteObject[] = withSurfaceStates('ai', [
  { path: '/ai', element: <AiIndexScreen /> },
  { path: '/ai/:id/compare', element: <CompareScreen /> },
  { path: '/ai/:id/plan', element: <PlanScreen /> },
  { path: '/ai/:id/budget', element: <BudgetScreen /> },
  { path: '/ai/:conversationId', element: <ConversationScreen /> },
]);
